import React from 'react'
import { Modal } from 'react-bootstrap'

interface GrowthWheelModalVisualizerProps {
    imageUrl: string
    show: boolean
    onClose: () => void
}

const GrowthWheelModalVisualizer = ({ imageUrl, show, onClose }: GrowthWheelModalVisualizerProps) => {
    return (
        <div
            className="modal fade show d-block"
            role="dialog"
            tabIndex={-1}
            style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
            onClick={onClose}
        >
            <div
                className="modal-dialog modal-dialog-centered modal-xl"
                role="document"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-content border-0">
                    <div className="modal-body p-0 position-relative">
                        <button
                            type="button"
                            className="btn-close position-absolute end-0 mt-2 me-2"
                            aria-label="Close"
                            onClick={onClose}
                        />
                        <img
                            src={imageUrl}
                            alt="Growth Wheel fullscreen"
                            className="w-100 h-100"
                            style={{ objectFit: 'contain', maxHeight: '80vh' }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GrowthWheelModalVisualizer